import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';

import { fetchDataPortability } from 'redux/modules/dataPortability';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class DataPortability extends Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.fetchDataPortability({
      triggerLoading: true,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { loading, history } = this.props;
    if (loading > 0
      && nextProps.loading === 0) {
      if (nextProps.dataPortability.length === 0) {
        history.replace('/settings');
      } else {
        const firsVariant = nextProps.dataPortability[0].Route;
        history.replace(`/settings/data-portability/${firsVariant}`);
      }
    }
  }

  render() {
    const { loading } = this.props;
    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Data Portability
          </title>
        </Helmet>
        {(loading > 0) &&
          <Progress />
        }
      </Layout>
    );
  }
}

DataPortability.propTypes = {
  dataPortability: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    Route: PropTypes.string.isRequired,
  })).isRequired,
  loading: PropTypes.number.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    fetchDataPortability: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = store => ({
  dataPortability: store.dataPortability.data,
  loading: store.dataPortability.loading,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchDataPortability }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DataPortability);



// WEBPACK FOOTER //
// ./src/pages/settings/DataPortability.js